import { render } from "./commessaDeleteBtn.vue?vue&type=template&id=0c132fe1"
import script from "./commessaDeleteBtn.vue?vue&type=script&lang=js"
export * from "./commessaDeleteBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__